import { actionWillPush, favoritePushWindowOpen } from '@pulsify/shared'
import type { ListingActionDto } from '@pulsify/shared/dto'

export type ActionPushStatus =
  | { kind: 'sent'; count: number }
  | { kind: 'sending' }
  | { kind: 'morning' }
  | { kind: 'never' }
  | { kind: 'missed' }

/**
 * What becomes of an action's push: sent to how many, on its way, waiting for 08:00, not going
 * out because the action ends before then, or never sent.
 */
export function actionPushStatus(
  action: Pick<ListingActionDto, 'pushedAt' | 'recipientCount' | 'endsAt' | 'endedAt'>,
  now: Date,
): ActionPushStatus {
  if (action.pushedAt) {
    return action.recipientCount === null
      ? { kind: 'sending' }
      : { kind: 'sent', count: action.recipientCount }
  }
  const endsAt = new Date(action.endsAt)
  if (action.endedAt || endsAt.getTime() <= now.getTime()) return { kind: 'missed' }
  if (favoritePushWindowOpen(now)) return { kind: 'sending' }
  return actionWillPush(endsAt, now) ? { kind: 'morning' } : { kind: 'never' }
}
